import {
  GET_CHATBOT_QA,
  ADD_CHATBOT_QA,
  DELETE_CHATBOT_QA,
  UPDATE_CHATBOT_QA,
  GET_QUESTIONS_EN_ATTENTE,
  DELETE_QUESTION_EN_ATTENTE,
  REPONDRE_QUESTION_EN_ATTENTE,
  GET_CHATBOT_STATS,
} from "../actions/chatbot.actions";

const initialState = {
  chatbotQA: [],
  questionsEnAttente: [],
  stats: null, // Initialisation des stats
};

export default function chatbotReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CHATBOT_QA:
      return { ...state, chatbotQA: action.payload };

    case GET_CHATBOT_STATS:
      return { ...state, stats: action.payload };

    case ADD_CHATBOT_QA:
      return {
        ...state,
        chatbotQA: [...state.chatbotQA, action.payload],
      };
    case DELETE_CHATBOT_QA:
      return {
        ...state,
        chatbotQA: state.chatbotQA.filter((item) => item.id !== action.payload),
      };
    case UPDATE_CHATBOT_QA:
      return {
        ...state,
        chatbotQA: state.chatbotQA.map((item) =>
          item.id === action.payload.id ? action.payload : item
        ),
      };
    case GET_QUESTIONS_EN_ATTENTE:
      return {
        ...state,
        questionsEnAttente: action.payload,
      };
    case DELETE_QUESTION_EN_ATTENTE:
      return {
        ...state,
        questionsEnAttente: state.questionsEnAttente?.filter((item) => item.id !== action.payload) || [],
      };
    case REPONDRE_QUESTION_EN_ATTENTE:
      return {
        ...state,
        questionsEnAttente: state.questionsEnAttente?.filter((item) => item.id !== action.payload) || [],
      };
    default:
      return state;
  }
};
